import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as FlowsRoute } from './FlowsRoute';

export default {
	actions,
	reducers,
	sagas
};
